export const SAVE_WHITELABEL = 'whitelabel/SAVE_WHITELABEL';
export const LOADING = 'whitelabel/LOADING';